import { useState } from 'react';
import { useAnalytics } from 'hooks/useAnalytics';
import { InputExtraLarge, SecondaryButtonExtraLarge } from 'elements/Forms';
import { Heading3 } from 'elements/Typography';

const BlogCta = () => {
  const { identify, track } = useAnalytics();
  const [subscribed, setSubscribed] = useState(false);

  const blogSubscribe = async (event) => {
    event.preventDefault();

    let email = event.target.email.value;
    email = email.trim().toLowerCase();

    setSubscribed(true);

    await identify(email);
    await track('Subscribed to the Blog', {
      email,
    });
  };

  return (
    <div className="mx-auto mt-12 max-w-lg rounded-2xl bg-blue-06 p-16 text-center shadow-md lg:max-w-none">
      <Heading3 as="p" className="text-white">
        Sales, deal management, and communication tips for your inbox
      </Heading3>
      <div className="mt-6">
        {!subscribed ? (
          <form
            onSubmit={blogSubscribe}
            className="flex flex-row justify-center gap-x-4"
          >
            <label htmlFor="emailAddress" className="w-full max-w-sm">
              <span className="sr-only">Email</span>
              <InputExtraLarge
                type="email"
                autoComplete="email"
                name="email"
                id="email"
                placeholder="Enter your email"
                required
              />
            </label>
            <SecondaryButtonExtraLarge type="submit" className="w-full sm:w-auto sm:flex-shrink-0">
              Subscribe
            </SecondaryButtonExtraLarge>
          </form>
        ) : (
          <p className="mt-3 text-lg text-white">Thanks for subscribing…</p>
        )}
      </div>
    </div>
  );
};

export default BlogCta;
